import styled from "styled-components";

export const THead = styled.thead`
  background: #f2f1fa 0% 0% no-repeat padding-box;
  height: 34px;
  opacity: 1;
`;

export const Th = styled.th`
  font-family: muli, sans-serif;
  font-weight: 800;
  font-style: normal;
  color: #b8b4cc;
  text-align: center;
  letter-spacing: 0px;
  opacity: 1;
  text-transform: uppercase;
`;

export const ThFilterable = styled.th`
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: muli, sans-serif;
  font-weight: 800;
  font-style: normal;
  color: #b8b4cc;
  text-align: center;
  letter-spacing: 0px;
  opacity: 1;
  text-transform: uppercase;
`

export const Td = styled.td`
  font-family: muli, sans-serif;
  font-weight: 300;
  font-size: normal;
  color: #172b4d;
  text-align: center;
  vertical-align: middle !important;
  letter-spacing: 0px;
  opacity: 1;
  text-transform: uppercase;
`;